<template>
    <!-- 活动-优惠券-优惠券类型-批量发放 -->
    <div>
        <!-- 对话框 -->
        <el-drawer
            title="发放优惠券"
            :visible.sync="show"
            :with-header="false"
            :before-close="closeDialog"
            size="600px"
            destroy-on-close
            :wrapperClosable="false"
        >
            <!-- 基本信息表单 -->
            <div class="form-box priority">
                <template>
                    <el-form ref="form" :model="submit_data_send" label-width="130px" style="height: 90vh; overflow-y: auto">
                        <div>
                            <el-form-item>
                                <div>
                                    <el-button type="primary" style="margin-bottom: 10px" @click="download1">下载模板</el-button>
                                    <div style="color: red; font-size: 12px">
                                        注：下载的csv表格文件，第一列为手机号，手机号只能为纯数字，第二列为优惠券数量<br />注：发放数量要小于等于添加优惠券时填写的数量，执行过程中不能关闭或刷新页面
                                    </div>

                                    <el-upload
                                        style="width: 350px; height: 200px; line-height: 20px"
                                        class="upload-demo"
                                        drag
                                        accept=".csv"
                                        :action="text_upload_url"
                                        :file-list="fileList"
                                        :before-upload="beforeAvatarUpload"
                                        :headers="text_headers"
                                        :data="submit_data_send"
                                        :on-success="getExcelData"
                                        multiple
                                    >
                                        <div class="el-upload__text upload">将文件拖到此处，或<em>点击上传</em></div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </div>
                    </el-form>
                    <!-- 对话框底部按钮 -->
                    <div style="display: flex; justify-content: center">
                        <el-button @click="closeDialog">关闭</el-button>
                    </div>
                </template>
            </div>
        </el-drawer>
    </div>
</template>

<script>
var _this;
//设置一个遮罩层缓存
var loading;
import { config } from '@/utils/config'; // 配置
//终端安装插件 npm install --save csv-exportor
// import {exportCsv} from '@/utils/utils.js';
import CsvExportor from 'csv-exportor'; //引入安装的插件

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this.submit_data_send.coupon_mode_code = _this.data;
        }
    },
    data() {
        return {
            fileList: [],
            fail_reason: [], // 批量上传返回的错误数据

            //翻页数据
            search_data: {
                page: 1,
                limit: 10
            },

            downFileData: [{ phone: '13454565434', startLine: '2' }], //csv 文件数据

            text_upload_url: config.axios_baseURL + '/coupon/addCanSendCouponMode',
            // 上传文件的请求头
            text_headers: {
                'city-tag': '',
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'service-tag':''
            },

            excelData: [],

            show: false,

            // 表单数据

            submit_data_send: {
                coupon_mode_code: '',
                file_name: ''
            },

            submit_rules: {
                startLine: {
                    placeholder: 'startLine',
                    rules: {
                        required: true,
                        message: 'startLine不正确',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                file: {
                    placeholder: 'file',
                    rules: {
                        required: true,
                        message: 'file不正确',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                coupon_mode_code: {
                    placeholder: '优惠券编码',
                    rules: {
                        required: false,
                        message: '优惠券编码不正确',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },

    created() {
        _this = this;
    },

    methods: {
        // 浏览器禁止刷新
        beforeUnload(event) {
            // 设置returnValue属性以显示提示信息
            event.returnValue = '你确定要离开吗？';

            // 注意：现代浏览器不允许自定义提示信息，只会显示一个标准的警告信息
        },
        // 批量上传接口
        addCanSendCouponMode() {
            _this
                .$post('/coupon/addCanSendCouponMode', _this.submit_data_send, _this.search_rules)
                .then((res) => {
                    _this.submit_data_send.startLine = res.data.startLine;
                    _this.submit_data_send.file_name = res.data.file;

                    if (res.data.fail_reason.length > 0) {
                        for (let i = 0; i < res.data.fail_reason.length; i++) {
                            _this.fail_reason.push({
                                phone: res.data.fail_reason[i][0],
                                num: res.data.fail_reason[i][1],
                                why: res.data.fail_reason[i][2]
                            });
                        }
                    }
                    console.log(_this.fail_reason, '_this.fail_reason----1');
                    console.log(res.data.startLine !== -1, 'res.data.startLine > -1');

                    if (res.data.startLine !== -1) {
                        console.log('if');
                        _this.addCanSendCouponMode();
                    } else {
                        console.log(_this.fail_reason, '_this.fail_reason----2');

                        if (_this.fail_reason.length > 0) {
                            this.$message.error('符合条件数据已导入，异常数据见excel表格！');
                            if (this.$route.path == '/couponType') {
                                // 导出excel的空数组中添加数据
                                for (let i = 0; i < _this.fail_reason.length; i++) {
                                    console.log(_this.fail_reason[i], i);
                                    // 向excelData数组里添加
                                    _this.excelData.push({
                                        phone: _this.fail_reason[i].phone,
                                        num: _this.fail_reason[i].num,

                                        why: _this.fail_reason[i].why
                                    });
                                }
                                console.log(_this.excelData, '_this.excelData');

                                // 将数据导出excel
                                _this.exportData();

                                // 清空数据

                                _this.closeDialog();
                            }
                        } else {
                            _this.$emit('onSubmit');
                            _this.closeDialog();

                            this.$message.success('操作完成');
                        }
                    }
                })
                .catch((err) => {});
        },

        // 下载模板方法
        download1() {
            let tableData = _this.downFileData;

            let header = ['13345678765', '1'];
            CsvExportor.downloadCsv(tableData, { header }, '批量上传优惠券模板.csv');
        },
        // 上传文件之前的钩子
        beforeAvatarUpload(file) {
            // 添加请求头
            _this.text_headers['city-tag'] = localStorage.getItem('city_tag');
            _this.text_headers.token = localStorage.getItem('access_token');
            _this.text_headers['hash-key'] = _this.$hash_key();
            _this.text_headers['service-tag'] = localStorage.getItem('service_tag');

        },
        //文件上传成功时的钩子
        getExcelData(response) {
            console.log(response, 'response');
            if (response.msg == 'success') {
                loading = _this.$loading({
                    lock: true,
                    text: '数据处理中,请勿刷新页面，请耐心等待...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.7)',
                    customClass: 'sendCoupon-loading'
                });

                window.addEventListener('beforeunload', this.beforeUnload);
                _this.submit_data_send.startLine = response.data.startLine;
                _this.submit_data_send.file_name = response.data.file;

                _this.addCanSendCouponMode();
            }
        },
        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = ['电话号', '数值', '失败原因'];
            const filterVal = ['phone', 'num', 'why'];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, '导入失败数据');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        // 关闭方法
        closeDialog() {
            _this.fileList = []; // 清空文件列表
            window.removeEventListener('beforeunload', this.beforeUnload);
            _this.show = false;

            // 如果loading存在则关闭loading遮罩
            if (loading) {
                loading.close();
            }

            _this.search_data = {
                page: 1,
                limit: 10
            };
            _this.downFileData = [{ phone: '13454565434', startLine: '2' }];
            _this.text_upload_url = config.axios_baseURL + '/coupon/addCanSendCouponMode';
            _this.text_headers = {
                'city-tag': '',
                token: '',
                'hash-key': '',
                platform: 'pc',
                'app-version': 'admin',
                port: 'admin',
                'service-tag':''
            };
            _this.excelData = [];

            _this.fail_reason = [];

            _this.submit_data_send = {
                coupon_mode_code: '',
                file_name: ''
            };

            // 触发父组件自定义事件刷新表格
            _this.$emit('onSubmit');
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
<style>
.priority .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
    margin-top: 10px;
}
.sendCoupon-loading .el-loading-text {
    font-size: 30px !important;
    color: red !important;
}
</style>